/**
 * Flush (Flash) — the three-card betting game with a flush-friendly ranking.
 *
 * Betting, blind/seen play, side shows, show and pot limit are exactly Teen Patti's. The ranking is
 * Trail > Pure sequence > Colour (flush) > Sequence > Pair > High card, so a colour beats a plain run.
 * It reuses the Teen Patti engine with `flushRanking` switched on and its own game type.
 */
import { teenPattiEngine, type TeenPattiAction, type TeenPattiConfig, type TeenPattiLegal, type TeenPattiState, type TeenPattiView } from '../teenpatti/engine.js';
import type { GameEngine } from '../../core/types.js';

export type FlushConfig = TeenPattiConfig;
export type FlushState = TeenPattiState;
export type FlushAction = TeenPattiAction;
export type FlushLegal = TeenPattiLegal;
export type FlushView = Omit<TeenPattiView, 'gameType'> & { gameType: 'FLUSH' };

export const flushEngine: GameEngine<FlushConfig, FlushState, FlushAction, FlushView, FlushLegal> = {
  ...teenPattiEngine,
  gameType: 'FLUSH',
  defaultConfig: () => ({ ...teenPattiEngine.defaultConfig(), flushRanking: true }),
  normalizeConfig: (input) => teenPattiEngine.normalizeConfig({ flushRanking: true, ...input, variant: 'classic' }),
  getView: (s, seat) => ({ ...teenPattiEngine.getView(s, seat), gameType: 'FLUSH' }) as FlushView,
};
